export const CLASS_ENROLLMENT_STATUS_LABELS: Record<string, string> = {
  pending: "ລໍຖ້າຢືນຢັນ",
  contacted: "ຕິດຕໍ່ແລ້ວ",
  confirmed: "ຢືນຢັນທີ່ເຄົາເຕີແລ້ວ",
  rejected: "ປະຕິເສດ",
  duplicate: "ຊ້ຳ",
  converted: "ເປັນນັກຮຽນແລ້ວ",
};

export const CLASS_ENROLLMENT_STATUS_VARIANTS: Record<
  string,
  "default" | "secondary" | "destructive" | "outline"
> = {
  pending: "outline",
  contacted: "secondary",
  confirmed: "default",
  rejected: "destructive",
  duplicate: "outline",
  converted: "secondary",
};

export const CLASS_ENROLLMENT_GENDER_LABELS: Record<string, string> = {
  male: "ຊາຍ",
  female: "ຍິງ",
  other: "ອື່ນໆ",
};
